import { Avatar, darken } from '@mui/material'
import { IUserDetails } from '../../../shared/services/user-details/user-details.model';
import { useContext } from 'react';
import { UserDetailsContext } from '../../../context/user-details/user-details';
import { ImageOutlined } from '@mui/icons-material';
import { TooltipHover } from '../miscellaneous-components/tooltip-hover';
import { ImageDisplay } from './image-display';

export const AvatarDisplay: React.FC<{
  color: string,
  width: string,
  height: string,
  padding: number,
  userDetails?: IUserDetails,
  fontSize?: string;
  logo?: boolean;
  hover?: boolean;
  name?: string,
  all?: boolean,
  showFullNameHover?: boolean
  showPartnerLogo?: boolean
}> = ({ color, width, height, padding, userDetails, fontSize, logo = false, hover = false, showFullNameHover = false, name, all = false, showPartnerLogo = false }) => {

  const userDetailsContext = useContext(UserDetailsContext)

  const getInitials = (): string => {
    if (userDetails) {
      return userDetails.firstName.charAt(0).toUpperCase() + userDetails.surname.charAt(0).toUpperCase();
    }
    return ''
  };

  return (
    <>
      {userDetails && userDetails.firstName && userDetails.surname && !showFullNameHover &&
        < Avatar sx={{
          bgcolor: color ? color : '#e7e7e7', width, height, padding, fontSize, '&:hover': {
            bgcolor: hover ? color ? darken(color, 0.2) : '#b8b8b8' : color,
          },
        }}>
          {getInitials()}
        </Avatar >}
      {userDetails && userDetails.firstName && userDetails.surname && showFullNameHover &&
        <TooltipHover text={`${userDetails.firstName} ${userDetails.surname}`} backgroundColor='lightGrey.dark' placement='bottom' textColor='white'>
          < Avatar sx={{
            bgcolor: color ? color : '#e7e7e7', width, height, padding, fontSize, '&:hover': {
              bgcolor: hover ? color ? darken(color, 0.2) : '#b8b8b8' : color,
            },
          }}>
            {getInitials()}
          </Avatar >
        </TooltipHover>}
      {logo && !userDetailsContext.userDetails?.organisation.logoFilepath && !userDetailsContext.userDetails?.organisation.partnerLogoFilepath &&
        < Avatar sx={{ bgcolor: color ? color : '#e7e7e7', width, height, padding, fontSize }}>
          <ImageOutlined sx={{ color: 'common.white', fontSize: '3rem' }} />
        </Avatar>}
      {logo && userDetailsContext.userDetails?.organisation.logoFilepath && !showPartnerLogo &&
        <Avatar sx={{
          bgcolor: 'common.white', borderStyle: 'solid', borderWidth: '1px', borderColor: 'lightGrey.light',
          width, height, padding,
        }}>
          <ImageDisplay url={userDetailsContext.userDetails?.organisation.logoFilepath} alt='Company logo' />
        </Avatar>}
      {logo && userDetailsContext.userDetails?.organisation.partnerLogoFilepath && showPartnerLogo &&
        <Avatar sx={{
          bgcolor: 'common.white', borderStyle: 'solid', borderWidth: '1px', borderColor: 'lightGrey.light',
          width, height, padding,
        }}>
          <ImageDisplay url={userDetailsContext.userDetails?.organisation.partnerLogoFilepath} alt='Company logo' />
        </Avatar>}
      {!userDetails && !name && !logo && !showFullNameHover && < Avatar sx={{
        bgcolor: color ? color : '#e7e7e7', width, height, padding, fontSize, '&:hover': {
          bgcolor: hover ? color ? darken(color, 0.2) : '#b8b8b8' : color,
        }
      }} />}

      {!userDetails && !logo && showFullNameHover && all &&
        <TooltipHover text={'All'} backgroundColor='lightGrey.dark' placement='bottom' textColor='white'>
          < Avatar sx={{
            bgcolor: color ? color : '#e7e7e7', width, height, padding, fontSize, '&:hover': {
              bgcolor: hover ? color ? darken(color, 0.2) : '#b8b8b8' : color,
            }
          }}>
            {name}
          </Avatar>
        </TooltipHover>
      }
      {!userDetails && !logo && showFullNameHover && !all &&
        <TooltipHover text={'Unassigned'} backgroundColor='lightGrey.dark' placement='bottom' textColor='white'>
          < Avatar sx={{
            bgcolor: color ? color : '#e7e7e7', width, height, padding, fontSize, '&:hover': {
              bgcolor: hover ? color ? darken(color, 0.2) : '#b8b8b8' : color,
            }
          }}>
            {name}
          </Avatar>
        </TooltipHover>
      }
      {!userDetails && name && !logo && !all && !showFullNameHover &&
        < Avatar sx={{
          bgcolor: color ? color : '#e7e7e7', width, height, padding, fontSize, '&:hover': {
            bgcolor: hover ? color ? darken(color, 0.2) : '#b8b8b8' : color,
          }
        }}>
          {name}
        </Avatar>
      }
    </>
  )
}